import { render } from "./Embed.vue?vue&type=template&id=7be67b1c"
import script from "./Embed.vue?vue&type=script&lang=js"
export * from "./Embed.vue?vue&type=script&lang=js"
script.render = render

export default script